import React, { useState, useEffect } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import CheckBoxGroup from '../Select/CheckBoxGroupWithGroupName';
import Axios from 'axios';
import { useSnackbar } from 'notistack';

function PermissionAdminBox({ id, type, permission, refreshData }) {
   const [checkBox, setCheckBox] = useState([
      // {
      //   label: 'Dashboard หลัก',
      //   value: 'dashboardMain',
      //   checked: true,
      // },
      // {
      //   label: 'Dashboard ประวัติการใช้งาน',
      //   value: 'dashboardUsedHistory',
      //   checked: true,
      // },
      // {
      //   label: 'Dashboard ข้อมูลกิจกรรม',
      //   value: 'dashboardActivity',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการสิทธิ์พนักงาน',
      //   value: 'permissionManagement',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการสิทธิ์ผู้ดูแลระบบ',
      //   value: 'permissionAdmin',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการกระเป๋าส่วนกลาง (HR)',
      //   value: 'walletHrManagement',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการกระเป๋าธนาคาร',
      //   value: 'walletBankManagement',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการหลักเกณฑ์',
      //   value: 'ruleManagement',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการกิจกรรม',
      //   value: 'activityManagement',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการประเภทของรางวัล',
      //   value: 'categoryManagement',
      //   checked: true,
      // },
      // {
      //   label: 'จัดการของรางวัล',
      //   value: 'rewardManagement',
      //   checked: true,
      // },
      // {
      //   label: 'เรียกดูประวัติการแลกของรางวัล',
      //   value: 'rewardHistoryManagement',
      //   checked: true,
      // },
      // {
      //   label: 'รายงานการแลกของรางวัล',
      //   value: 'reportRewardRedeem',
      //   checked: true,
      // },
      // {
      //   label: 'รายงานของรางวัลคงเหลือ',
      //   value: 'reportTotalReward',
      //   checked: true,
      // },
      // {
      //   label: 'รายงานการสะสมคะแนน',
      //   value: 'reportCollectPoint',
      //   checked: true,
      // },
      // {
      //   label: 'ประวัติรายงาน',
      //   value: 'historyReport',
      //   checked: true,
      // },
      // {
      //   label: 'นำเข้าข้อมูล',
      //   value: 'uploadFiles',
      //   checked: true,
      // },
   ]);
   const [isCanEdit, setIsCanEdit] = useState();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   useEffect(() => {
      let temp = permission.find((el) => el.id === parseInt(id));
      if (temp) {
         setIsCanEdit(temp.isCanEdit);
         setCheckBox(
            temp.permissions.map((el) => {
               return {
                  canEdit: el.canEdit,
                  permissionId: el.permissionId,
                  label: el.permissionNameTh,
                  value: el.permissionNameEn,
                  checked: el.isEnable,
                  groupName: el.menuName,
                  groupId: el.menuId,
               };
            }),
         );
      }
   }, [permission, id]);
   const handleCheckboxGroupChange = (updatedUseCaseCBState) => {
      setCheckBox(updatedUseCaseCBState);
      let payload = {
         permissionGroupId: id,
         permissionList: updatedUseCaseCBState.map((el) => {
            return {
               permissionId: el.permissionId,
               isEnable: el.checked,
            };
         }),
      };
      Axios.post('/GSB/dashboard/permission/EditPermissionList', payload)
         .then((resp) => {
            enqueueSnackbar('แก้ไข Permission สำเร็จ', {
               variant: 'success',
            });
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };
   const renderPermissionBox = () => {
      if (!id) return <Typography>โปรดเลือกกลุ่มเพื่อจัดการสิทธิ์</Typography>;
      return (
         <Box display={'flex'} flexDirection='column' width={1}>
            <Box width={1}>
               <Box>
                  <Typography>จัดการสิทธิ์กลุ่ม {type}</Typography>
               </Box>
               <Divider />
            </Box>
            <Box display={'flex'} width={1}>
               <Box width='100%'>
                  <CheckBoxGroup
                     disabledAll={!isCanEdit}
                     title={'เลือกจัดการระบบหลังบ้านทั้งหมด'}
                     checkboxes={checkBox}
                     onCheckboxGroupChange={handleCheckboxGroupChange}
                  />
                  {/*<Box>เลือกจัดการระบบหลังบ้านทั้งหมด</Box>*/}
                  {/*<Divider />*/}
                  {/*<Box>*/}
                  {/*  <Box>เรียกดู Dashboard</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>Dashboard หลัก</Box>*/}
                  {/*    <Box>Dashboard กิจกรรม</Box>*/}
                  {/*    <Box>Dashboard ประวัติการใช้งาน</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>จัดการพนักงาน</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>จัดการสิทธิ์พนักงาน</Box>*/}
                  {/*    <Box>จัดการสิทธิ์ผู้ดูแลระบบ</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>จัดการกิจกรรม</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>จัดการกิจกรรม</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>จัดการหลักเกณฑ์</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>จัดการหลักเกณฑ์</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>คะแนน</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>จัดการอนุมัติให้คะแนน</Box>*/}
                  {/*    <Box>โอนคะแนน</Box>*/}
                  {/*    <Box>จัดการกระเป๋าส่วนกลาง (HR)</Box>*/}
                  {/*    <Box>จัดการกระเป๋าธนาคาร</Box>*/}
                  {/*    <Box>ค้นหากระเป๋าส่วนตัว</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>จัดการของรางวัล</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>จัดการประเภทของรางวัล</Box>*/}
                  {/*    <Box>จัดการของรางวัล</Box>*/}
                  {/*    <Box>เรียกดูประวัติการแลกของรางวัล</Box>*/}
                  {/*    <Box>เรียกดูของรางวัลคงเหลือ</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>รายงาน</Box>*/}
                  {/*  <Box>*/}
                  {/*    <Box>รายงานการแลกของรางวัล</Box>*/}
                  {/*    <Box>รายงานของรางวัลคงเหลือ</Box>*/}
                  {/*    <Box>รายงานการสะสมคะแนน</Box>*/}
                  {/*    <Box>ประวัติรายงาน</Box>*/}
                  {/*  </Box>*/}
                  {/*</Box>*/}
                  {/*<Box>*/}
                  {/*  <Box>อัปโหลดไฟล์</Box>*/}
                  {/*  <Box>อัปโหลดไฟล์</Box>*/}
                  {/*</Box>*/}
               </Box>
            </Box>
         </Box>
      );
   };
   return (
      <React.Fragment>
         <Typography>รายการสิทธิ์ที่อนุญาต</Typography>
         <Divider />
         <Box>{renderPermissionBox()}</Box>
      </React.Fragment>
   );
}

export default PermissionAdminBox;
